<template>
  <v-app id="portal">
    <v-content class="px-3">
      <titulo-responsivo :titulo="locale[local].screen.cartilha.string001" />
      <v-divider />

      <div class="ma-5">
        <v-card
          outlined
          elevation="0"
        >
          <v-card-text class="pa-0">
            <v-data-table
              :headers="headers"
              :items="items"
              disable-pagination
              hide-default-footer
            >
              <template v-slot:[`item.anexo`]="{ item }">
                <div class="d-flex justify-center">
                  <v-btn
                    color="primary"
                    class="white--text"
                    small
                    :href="
                      'data:application/octet-stream;base64,' + item.anexo
                    "
                    :download="item.nomeArquivo"
                    width="200"
                    max-width="200"
                  >
                    <span>
                      {{ locale[local].screen.cartilha.string002 }}
                    </span>
                    <v-icon
                      right
                      medium
                    > mdi-printer </v-icon>
                  </v-btn>
                </div>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </div>
    </v-content>
  </v-app>
</template>

<script>
import Service from "../components/api/Service";
export default {
  data: () => ({
    snackbar: false,
    loading: false,
    headers: [
      {
        text: "Descrição",
        value: "descricao",
        divider: true,
      },
      {
        text: "Observação",
        value: "observacao",
        divider: true,
      },
      {
        text: "Anexo",
        value: "anexo",
        align: "center",
        width: "100px",
        custom: true,
      },
    ],
    items: [],
  }),
  async mounted() {
    const service = new Service();
    this.items = await service.buscaCartilha();
  },
  computed: {
  },
  methods: {
  },
};
</script>
